import { render } from "./purchaseInBill.vue?vue&type=template&id=4718235b&scoped=true&ts=true"
import script from "./purchaseInBill.vue?vue&type=script&lang=ts"
export * from "./purchaseInBill.vue?vue&type=script&lang=ts"

import "./purchaseInBill.vue?vue&type=style&index=0&id=4718235b&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4718235b"]])

export default __exports__